import { render } from "./bulk_topup.vue?vue&type=template&id=268f943f&scoped=true"
import script from "./bulk_topup.vue?vue&type=script&lang=js"
export * from "./bulk_topup.vue?vue&type=script&lang=js"

import "./bulk_topup.vue?vue&type=style&index=0&id=268f943f&scoped=true&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-268f943f"]])

export default __exports__